export class Client {
    constructor(public id: number, public name: string) { }
}

export interface IClientResponse {
    results: Client[];
}
